











































































































































import EmployeSelect from "../core/Forms/EmployeSelect.vue";
import { InterventionApi } from "../api/InterventionApi";
import CheckboxInput from "../core/Forms/CheckboxInput.vue";
import ExportButton from "../core/UI/ExportButton.vue";
import moment from "moment";

// À garder aligné avec App\Exports\Intervention\PlanningPdfHandler::MAX_DAYS.
const MAX_DAYS_ALL_EMPLOYES = 92;
const DOWNLOAD_BUTTON_LOCK_MS = 5000;

export default {
    name: "PrintPlanning",
    components: { CheckboxInput, EmployeSelect, ExportButton },
    data() {
        return {
            selectedEmploye: null,
            selectedDateRange: null,
            InterventionApi: new InterventionApi(),
            debugMode: false,
            loading: false,
            pdfUrl: "about:blank",
            // Numéro de la dernière demande d'aperçu : les URL signées des
            // demandes précédentes, arrivées en retard, sont ignorées.
            previewRequestId: 0,
            maxDaysAllEmployes: MAX_DAYS_ALL_EMPLOYES,
            // false si le navigateur n'a pas de visionneuse PDF ou est réglé
            // pour télécharger les PDF (AW-44). Absent des navigateurs
            // antérieurs à 2021 : on suppose alors une visionneuse.
            pdfViewerEnabled: (navigator as any).pdfViewerEnabled !== false,
            downloading: false,
        };
    },
    computed: {
        // Option « Tous les employés » du sélecteur (id 0).
        allEmployes: function (): boolean {
            return !!this.selectedEmploye && this.selectedEmploye.id === 0;
        },
        periodTooLong: function (): boolean {
            return (
                !!this.selectedDateRange &&
                moment(this.selectedDateRange.end).diff(
                    moment(this.selectedDateRange.start),
                    "days"
                ) > MAX_DAYS_ALL_EMPLOYES
            );
        },
        // Change dès qu'un critère de l'aperçu change.
        previewKey: function (): string {
            if (
                !this.selectedEmploye ||
                this.allEmployes ||
                !this.selectedDateRange
            ) {
                return "";
            }

            return [
                this.selectedEmploye.id,
                moment(this.selectedDateRange.start).format("YYYY-MM-DD"),
                moment(this.selectedDateRange.end).format("YYYY-MM-DD"),
                this.debugMode,
            ].join("|");
        },
    },
    watch: {
        previewKey: function () {
            this.loadPreview();
        },
    },
    methods: {
        loadPreview: function () {
            let self = this;
            let requestId = ++self.previewRequestId;

            self.pdfUrl = "about:blank";

            if (!self.previewKey || !self.pdfViewerEnabled) {
                self.loading = false;
                return;
            }

            self.loading = true;

            self.InterventionApi.getPlanningPdfSignedUrl(
                self.selectedEmploye.id,
                self.selectedDateRange.start,
                self.selectedDateRange.end,
                self.debugMode
            )
                .then(function (url) {
                    // Changer src annule le chargement précédent : seul le
                    // dernier aperçu demandé déclenche load.
                    if (requestId === self.previewRequestId) {
                        self.pdfUrl = url;
                    }
                })
                .catch(function () {
                    if (requestId === self.previewRequestId) {
                        self.loading = false;
                        swal("La génération du planning a échoué", "", "error");
                    }
                });
        },
        downloadPdf: function () {
            let self = this;

            // La fin du téléchargement n'est pas détectable : le bouton est
            // seulement désactivé quelques secondes contre le double clic.
            self.downloading = true;
            setTimeout(function () {
                self.downloading = false;
            }, DOWNLOAD_BUTTON_LOCK_MS);

            self.InterventionApi.getPlanningPdfSignedUrl(
                self.selectedEmploye.id,
                self.selectedDateRange.start,
                self.selectedDateRange.end,
                self.debugMode
            )
                .then(function (url) {
                    self.pdfUrl = url;
                })
                .catch(function () {
                    swal("La génération du planning a échoué", "", "error");
                });
        },
        onPdfLoaded: function () {
            if (this.pdfUrl !== "about:blank") {
                this.loading = false;
            }
        },
        getExportParams: function (): Object {
            return {
                startDate: moment(this.selectedDateRange.start).format(
                    "YYYY-MM-DD"
                ),
                endDate: moment(this.selectedDateRange.end).format(
                    "YYYY-MM-DD"
                ),
            };
        },
    },
    destroyed() {
        this.previewRequestId++;
    },
};
